import request from '@/utils/request'

export default {
  // 获取应用列表
  getList(params) {
    return request({
      url: '/console/applications',
      method: 'get',
      params
    })
  },
  // 编辑应用
  editApplication(id, params) {
    return request({
      url: `/console/applications/${id}`,
      method: 'put',
      data: params
    })
  },
  // 添加应用
  addApplication(params) {
    return request({
      url: `/console/applications`,
      method: 'POST',
      data: params
    })
  },
  // 获取用户列表
  getUserList(params) {
    return request({
      url: '/console/users',
      method: 'get',
      params
    })
  },
  // 是否启用应用
  isEnabledApp(id, params) {
    return request({
      url: `/console/applications/${id}/is-enabled`,
      method: 'get',
      params
    })
  },
  // 资源授权
  authorizeApp(id, params) {
    return request({
      url: `/console/applications/${id}/authorize`,
      method: 'POST',
      data: params
    })
  },
  // 重置应用密匙
  resetSecret(id) {
    return request({
      url: `/console/applications/${id}/reset-app-key`,
      method: 'PUT'
    })
  }
}
